class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.primaryImage = this.querySelector("[data-primary-image]");
    this.links = this.querySelectorAll("[data-product-link]");
    this.productTitle = this.querySelector("[data-product-title]");
    this.productPrice = this.querySelector("[data-current-price]");
  }

  connectedCallback() {
    this.addEventListener("change", (e) =>
      this.handleVariantButtonClick(e.target),
    );
  }

  handleVariantButtonClick(input) {
    const variantUrl = input.dataset.productUrl;
    const variantImage = input.dataset.featuredImage;
    const variantTitle = input.dataset.productTitle;
    const varId = input.dataset.variantId;

    this.links.forEach((link) => {
      link.href = variantUrl;
    });

    this.productTitle.innerHTML = `<a data-product-link href="${variantUrl}">${variantTitle}</a>`;
    this.primaryImage.innerHTML = `<div class="image"><picture><img src="${variantImage}" /></picture></div>`;

    const priceHtml = this.querySelector(`[data-price="${varId}"]`).innerHTML;
    this.productPrice.innerHTML = priceHtml;
  }
}

if (!customElements.get("product-card")) {
  customElements.define("product-card", ProductCard);
}
